var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Notification'),_c('Balance'),_c('Report',{attrs:{"enable":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }